import {Platform} from 'react-native';
import FastImage from 'react-native-fast-image';
import {ScrollView} from 'react-native-gesture-handler';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import {css} from 'styled-components/native';
import styled from 'styled-components/native';
import LinearGradient from 'react-native-linear-gradient';

interface PriceRank {
  gold?: boolean;
}

export const Container = styled.TouchableOpacity`
  padding: ${RFValue(0)}px 24px;
  border-style: solid;
  padding-bottom: ${RFValue(14)}px;

  position: relative;
`;

export const StationContainer = styled.View``;

export const Station = styled.View`
  border: 1px solid ${({theme}) => theme.colors.border};
  padding: ${RFValue(12)}px ${RFValue(12)}px;
  border-radius: ${RFValue(20)}px;
  z-index: 1;

  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.1;
  shadow-radius: 8px;
  elevation: 4;
  background-color: ${({theme}) => theme.colors.background};
`;

export const StationGradient = styled(LinearGradient)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 80%;
  z-index: -1;
`;

export const PromotionWrapper = styled.TouchableOpacity`
  flex-direction: row;
  align-items: flex-start;

  margin-bottom: -${RFValue(70)}px;
  max-width: 85%;
`;

export const PromotionContainer = styled.View`
  flex-direction: row;
  flex: 1;
  height: ${RFValue(90)}px;
  background-color: ${({theme}) => theme.colors.hot_background_opacity};
  border-radius: ${RFValue(30)}px;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  overflow: hidden;
`;

export const PromotionBanner = styled.View`
  padding: 0 ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.hot_background_opacity};

  padding-top: ${RFValue(4)}px;
  height: ${RFValue(20)}px;

  flex: 1;

  align-items: flex-start;
  flex-direction: row;
`;

export const PromotionArrow = styled.View`
  width: 0;
  height: 0;
  border-top-width: ${RFValue(10)}px;
  border-bottom-width: ${RFValue(10)}px;
  border-left-width: ${RFValue(14)}px;
  margin-left: -1px;
  border-top-color: transparent;
  border-bottom-color: transparent;
  border-left-color: ${({theme}) => theme.colors.hot_background_opacity};
  align-self: stretch;
`;

export const PromotionBannerColumn = styled.View`
  align-items: center;
  flex-direction: row;
`;

export const PromotionIconContainer = styled.View`
  margin-right: ${RFValue(4)}px;
`;
export const PromotionEmoji = styled(MaterialIcons)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.shape};
`;

export const IoniconsTicket = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(10)}px;
  margin-right: ${RFValue(6)}px;
`;
export const WhiteLine = styled.View`
  background-color: rgba(255, 255, 255, 0.5);
  width: 1px;
  height: ${RFValue(12)}px;
`;

export const PromotionIconRight = styled(Feather)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(10)}px;
`;

export const PromotionIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  margin-right: ${RFValue(6)}px;
`;

export const PromotionText = styled.Text`
  color: ${({theme}) => theme.colors.shape};

  font-size: ${RFValue(9)}px;
  align-items: center;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const PromotionTextBold = styled.Text`
  color: ${({theme}) => theme.colors.shape};

  font-size: ${RFValue(9)}px;
  align-items: center;
  font-family: ${({theme}) => theme.fonts.bold};
`;
export const PromotionCoupon = styled.Text`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(8)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const PromotionProduct = styled.Text``;

export const StationContext = styled.View``;

export const StationIcon = styled(FontAwesome)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.shape};
`;

export const StationNaoDisponivel = styled.View`
  text-align: center;
  position: absolute;
  top: 0;
  border-radius: ${RFValue(16)}px;
  left: 0;
  background-color: ${({theme}) => theme.colors.mask_station};
  width: 100%;
  height: 100%;
  justify-content: center;
  z-index: 100;
  align-items: center;
`;

export const StationTextNaoDisponivel = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
`;

export const StationSubtitleNaoDisponivel = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(11)}px;
`;

export const PromotionContent = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  gap: ${RFValue(6)}px;
`;

export const StationContent = styled.View`
  flex-direction: row;
  align-items: center;

  justify-content: space-between;
`;

export const StationColumn = styled.View`
  flex-direction: row;
  align-items: center;
  flex: 1;
`;

//@ts-ignore
export const StationImage = styled(FastImage)`
  height: ${RFValue(40)}px;
  width: ${RFValue(40)}px;

  border-radius: ${RFValue(40)}px;
`;

export const DistanceContainer = styled.View`
  flex-direction: row;
  gap: ${RFValue(4)}px;
  align-items: center;
  justify-content: center;
`;

export const StationInfos = styled.View`
  margin: 0 ${RFValue(8)}px;
  flex: 1;
`;

interface ShowRankProps {
  showRank?: boolean;
}

export const StationColumnRight = styled.View<ShowRankProps>`
  padding-right: ${RFValue(30)}px;

  ${({showRank}) =>
    !showRank &&
    css`
      padding-right: ${RFValue(0)}px;
    `}
`;

export const StationName = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(11)}px;
  margin-bottom: ${Platform.OS === 'ios' ? RFValue(2) : 0}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const StationDetails = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const StationAddress = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  text-transform: capitalize;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const DistanceIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.primary};
  font-size: ${RFValue(12)}px;
  margin-left: ${RFValue(6)}px;
  margin-bottom: ${RFValue(2)}px;
`;

export const PricesContainer = styled.View`
  background-color: ${({theme}) => theme.colors.background_black};
  border: 1px solid ${({theme}) => theme.colors.border};
  padding: ${RFValue(6)}px ${RFValue(16)}px;
  padding-top: ${RFValue(16)}px;
  margin-top: -${RFValue(18)}px;

  border-top-width: 0;
  border-bottom-left-radius: ${RFValue(20)}px;
  border-bottom-right-radius: ${RFValue(20)}px;
`;

//@ts-ignore
export const Prices = styled(ScrollView)`
  margin-right: -12px;
  margin-left: -12px;

  z-index: 30;
`;
export const PriceItem = styled.TouchableOpacity<PriceRank>`
  padding: ${RFValue(2)}px ${RFValue(6)}px;
  background: transparent;
  margin-right: ${RFValue(6)}px;
  border-radius: ${RFValue(8)}px;
  border-width: ${RFValue(1)}px;
  border-style: solid;
  border-color: transparent;

  ${({gold}) =>
    gold &&
    css`
      background: ${({theme}) => theme.colors.gold}20;
      border-color: ${({theme}) => theme.colors.gold_dark};
    `}
`;

export const Price = styled.Text<PriceRank>`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(15)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  line-height: ${RFValue(18)}px;
  ${({gold}) =>
    gold &&
    css`
      color: ${({theme}) => theme.colors.gold_dark};
    `}
`;
export const PriceProduct = styled.Text<PriceRank>`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.bold};

  ${({gold}) =>
    gold &&
    css`
      color: ${({theme}) => theme.colors.gold_dark};
    `}
`;

export const OldPriceWrapper = styled.View`
  align-self: flex-start;
`;

export const OldPrice = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(11)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  line-height: ${RFValue(14)}px;
`;

export const OldPriceStrike = styled.View`
  position: absolute;
  left: -2px;
  right: -2px;
  top: 45%;
  height: 2px;
  background-color: ${({theme}) => theme.colors.hot_background_opacity};
  transform: rotate(-8deg);
`;

export const OTPWarning = styled.Text`
  color: ${({theme}) => theme.colors.hot_background_opacity};
  font-size: ${RFValue(9)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  margin-top: ${RFValue(8)}px;
`;

export const OTPWarningLight = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(8)}px;
`;

export const Distance = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(9)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const StationBadge = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const StationNameMedal = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const Arrow = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;
export const Distance1 = styled.Text`
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  text-decoration: underline;
`;

export const DiscountContainer = styled.TouchableOpacity`
  flex-direction: row;
  margin-top: -${RFValue(55)}px;
  z-index: -1;
  border-radius: ${RFValue(20)}px;
  justify-content: flex-end;
  align-items: flex-end;
  background-color: ${({theme}) => theme.colors.yellow};
  height: ${RFValue(80)}px;
`;

export const DiscountBanner = styled.View`
  padding: 0 ${RFValue(12)}px;

  height: ${RFValue(25)}px;
  border-radius: ${RFValue(20)}px;
  flex: 1;
  align-items: center;
  flex-direction: row;
`;

export const DiscountBannerColumn = styled.View`
  align-items: center;
  flex-direction: row;
`;

export const DiscountIconContainer = styled.View`
  margin-right: ${RFValue(6)}px;
`;
export const DiscountEmoji = styled(MaterialIcons)`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.black};
`;

export const DiscountContent = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

export const DiscountIconRight = styled(Feather)`
  color: ${({theme}) => theme.colors.black};
  font-size: ${RFValue(14)}px;
`;

export const DiscountIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.black};
  font-size: ${RFValue(14)}px;
  margin-right: ${RFValue(6)}px;
`;

export const DiscountText = styled.Text`
  color: ${({theme}) => theme.colors.black};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

type RankProps = {
  rank?: 'gold' | 'silver';
};

export const Badge = styled.View`
  position: absolute;
  top: 0;
  right: 0;
  width: ${RFValue(60)}px;
  height:${RFValue(60)}px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-top-right-radius: ${RFValue(16)}px;
  
`;
export const BadgeTriangle = styled.View<RankProps>`
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-top-width: ${RFValue(60)}px;
  border-left-width: ${RFValue(60)}px;
  border-top-color: ${({theme}) => theme.colors.silver};
  shadow-color: #000;
  shadow-offset: 0px 4px;
  shadow-opacity: 0.1;
  shadow-radius: 4px;
  ${({rank}) =>
    rank === 'gold' &&
    css`
      border-top-color: ${({theme}) => theme.colors.gold};
    `}
  border-left-color: transparent;
`;
export const BadgeText = styled.Text<RankProps>`
  font-family: ${({theme}) => theme.fonts.medium};
  position: absolute;

  color: #fff;
  font-size: ${RFValue(9)}px;

  ${({rank}) =>
    Platform.OS === 'android' &&
    css`
      line-height: ${RFValue(9)}px;
      top: ${RFValue(16)}px;
      right: ${RFValue(-1)}px;

      ${rank === 'gold' &&
      css`
        top: ${RFValue(11)}px;
        right: ${RFValue(-4)}px;
      `}
    `}


  ${({rank}) =>
    Platform.OS === 'ios' &&
    css`
      line-height: ${RFValue(11)}px;
      top: ${RFValue(16)}px;
      right: ${RFValue(0)}px;

      ${rank === 'gold' &&
      css`
        top: ${RFValue(7.5)}px;
        right: ${RFValue(-3)}px;
      `}
    `}

     ${({rank}) =>
    Platform.OS === 'web' &&
    css`
      line-height: ${RFValue(11)}px;
      top: ${RFValue(16)}px;
      right: ${RFValue(0)}px;

      ${rank === 'gold' &&
      css`
        top: ${RFValue(7.5)}px;
        right: ${RFValue(-3)}px;
      `}
    `}

  text-align: center;
  width: ${RFValue(45)}px;
  transform: rotate(45deg);
`;
export const BadgeTextBig = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(11)}px;
`;
